import api from "api";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "components/modal";
import React, { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react";
import { AccessTokenType, RootState } from "types";
import "./access-token.scss";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";

interface FacebookInstagramAccessTokenCheck {
    expires_at: Number;
    is_valid: Boolean;
    issued_at: Number;
}

interface InstagramAccessTokenCheck {
    expires_at: Number;
    is_valid: Boolean;
    issued_at: Number;
    error: {
        message: string;
    };
}

interface LinkedInAccessTokenCheck {
    expires_at: Number;
    active: Boolean;
    created_at: Number;
    status: String;
}

function AccessToken({ open, setOpen }: { open: boolean; setOpen: Dispatch<SetStateAction<boolean>> }) {
    const params: any = useParams();
    const project = useSelector((state: RootState) => state.project);
    const [promptOpen, setPromptOpen] = useState(false);
    const [influencerLinkOpen, setInfluencerLinkOpen] = useState(false);
    const [linkClicked, setLinkClicked] = useState(false);
    const [influencerLink, setInfluencerLink] = useState("");
    const [accessTokenModalHeader, setAccessTokenModalHeader] = useState("");
    const [accessTokenModalBody, setAccessTokenModalBody] = useState("");
    const [accessTokens, setAccessTokens] = useState<AccessTokenType[]>([]);
    const [section, setSection] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [link, setLink] = useState<string>("");
    const streams = [
        {
            id: 7,
            name: "X",
        },
        {
            id: 8,
            name: "Facebook",
        },
        {
            id: 9,
            name: "Instagram",
        },
        {
            id: 11,
            name: "LinkedIn",
        },
        {
            id: 12,
            name: "TikTok",
        },
    ];

    const validateTokens = useCallback(
        async (tokens: AccessTokenType[]) => {
            setAccessTokens([]);
            setLoading(true);
            let copied = [...tokens];
            for (let i = 0; i < tokens.length; i++) {
                let isValid = false;
                if (tokens[i].AccessToken) {
                    if (tokens[i].StreamId === 8) {
                        await validateFacebookToken(tokens[i].ProfileId, tokens[i].AccessToken).then((data) => (isValid = data));
                    } else if (tokens[i].StreamId === 9) {
                        await validateInstagramToken(tokens[i].ProfileId, tokens[i].AccessToken).then((data) => (isValid = data));
                    } else if (tokens[i].StreamId === 11) {
                        await api.accessToken.validateLinkedInToken(tokens[i].AccessToken).then((data) => {
                            if (data.status !== "expired") {
                                isValid = true;
                            }
                        });
                        // await validateLinkedInToken(tokens[i].ProfileId, tokens[i].AccessToken).then(data => isValid = data);;
                    } else if (tokens[i].StreamId === 12) {
                        await api.accessToken.validateTikTokToken(tokens[i].AccessToken).then((data) => (isValid = data));
                    }
                }
                let index = copied.map((x) => x.ProfileId).indexOf(tokens[i].ProfileId);
                let [removed] = copied.splice(index, 1);
                copied.splice(index, 0, {
                    ...removed,
                    IsValid: isValid,
                });
            }
            setLoading(false);
            return copied;
        },
        [setAccessTokens]
    );

    const getAccessTokens = useCallback(async () => {
        let data: AccessTokenType[] = await api.accessToken.getAll(params.projectId);
        data = await validateTokens(data);
        setAccessTokens(data.filter((x) => x.StreamId !== 7));
    }, [params.projectId, validateTokens]);

    const getStreamName = (id: number) => {
        return (
            {
                7: "x-twitter",
                8: "facebook",
                9: "instagram",
                10: "youtube",
                11: "linkedin",
                12: "tiktok",
            }[id] || ""
        );
    };

    const validateFacebookToken = async (profileId: string, token: string) => {
        let isValid = false;
        try {
            const res = await fetch(`https://graph.facebook.com/v18.0/${profileId}/feed?access_token=${token}`);
            const data = await res.json();
            if (data.data) {
                isValid = true;
            }
        } catch (err) {}
        return isValid;
    };

    const validateInstagramToken = async (profileId: string, token: string) => {
        try {
            const res = await fetch(`https://graph.facebook.com/v13.0/${profileId}/media?access_token=${token}`);
            if (res.ok == false) {
                return false;
            }
            await res.json();
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    };

    const validateLinkedInToken = async (profileId: string, token: string) => {
        if (token) {
            var t = api.accessToken.validateLinkedInToken(token).then((data: LinkedInAccessTokenCheck) => {
                return data.status == "expired" ? false : true;
            });
        }
        return false;
    };

    const validateTikTokToken = async (profileId: string, token: string) => {
        if (token) {
            var t = api.accessToken.validateTikTokToken(token).then((data: boolean) => {
                if (data == true) return true;
            });
        }
        return false;
    };

    const selectStream = async (id: number) => {
        setSection(3);
        if (project.ProjectTypeId === 5 || project.ProjectTypeId === 8) {
            const state = {
                clientId: params.clientId,
                projectId: params.projectId,
                streamId: id,
            };
            const origin = window.location.origin.replace("http:", "https:");

            setInfluencerLink(
                {
                    8: `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/brandInfluencer&response_type=token&scope=email,pages_show_list,ads_management,pages_manage_posts,pages_read_engagement&state=${JSON.stringify(
                        state
                    )}&profileId`,
                    9: `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/brandInfluencer&response_type=token&scope=pages_show_list,instagram_basic,pages_read_engagement,public_profile,email,instagram_manage_comments,instagram_manage_insights,instagram_content_publish&state=${JSON.stringify(
                        state
                    )}&profileId`,
                    10: `https://accounts.google.com/o/oauth2/v2/auth?client_id=468298763424-hoootuclqngm1kukab44s5sf8n9ubbum.apps.googleusercontent.com&redirect_uri=https://app.amasocial.co.za/brandInfluencer&response_type=token&scope=https://www.googleapis.com/auth/youtube.readonly&state=${JSON.stringify(
                        state
                    )}&profileId`,
                    11: `https://www.linkedin.com/oauth/v2/authorization?client_id=78y7hijgpe4o35&redirect_uri=https://app.amasocial.co.za/brandInfluencer&response_type=code&scope=r_basicprofile+r_emailaddress+r_organization_social+w_organization_social+rw_organization_admin+w_member_social&state=${JSON.stringify(
                        state
                    )}&profileId`,
                    12: `https://www.tiktok.com/v2/auth/authorize?client_key=aww67t4ioyiuvnr9&response_type=code&scope=user.info.basic,video.list&redirect_uri=https://app.amasocial.co.za/profile&state=${JSON.stringify(state)}`,
                }[id] || ""
            );
            setOpen(false);
            setInfluencerLinkOpen(true);
        } else {
            const state = {
                clientId: params.clientId,
                projectId: params.projectId,
                streamId: id,
            };
            const origin = window.location.origin.replace("http:", "https:");

            setLink(
                {
                    7: `https://api.twitter.com/oauth/request_token?oauth_callback=${encodeURI(origin + "/profile")}&state=${JSON.stringify(state)}`,
                    8: `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/profile&response_type=token&scope=email,pages_show_list,ads_management,pages_manage_posts,pages_read_engagement&state=${JSON.stringify(
                        state
                    )}`,
                    9: `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/profile&response_type=token&scope=pages_show_list,instagram_basic,pages_read_engagement,public_profile,email,instagram_manage_comments,instagram_manage_insights,instagram_content_publish&state=${JSON.stringify(
                        state
                    )}`,
                    10: `https://accounts.google.com/o/oauth2/v2/auth?client_id=468298763424-hoootuclqngm1kukab44s5sf8n9ubbum.apps.googleusercontent.com&redirect_uri=https://app.amasocial.co.za/profile&response_type=token&scope=https://www.googleapis.com/auth/youtube.readonly&state=${JSON.stringify(
                        state
                    )}`,
                    11: `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78y7hijgpe4o35&redirect_uri=https://app.amasocial.co.za/brandInfluencerprofile&scope=r_basicprofile+r_emailaddress+r_organization_social+w_organization_social+rw_organization_admin+w_member_social&state=${JSON.stringify(
                        state
                    )}`,
                    12: `https://www.tiktok.com/v2/auth/authorize?client_key=aww67t4ioyiuvnr9&response_type=code&scope=user.info.basic,video.list&redirect_uri=https://app.amasocial.co.za/profile&state=${JSON.stringify(state)}`,
                }[id] || ""
            );
        }
    };

    const onClick = (profileId: string, streamId: number, accessToken: string, isValid: boolean, e: React.MouseEvent) => {
        e.stopPropagation();
        if (!accessToken || !isValid) {
            redirect(streamId, profileId);
        } else {
            if (window.confirm("Are you sure you want to revoke this access token?")) {
                revoke(streamId, profileId);
            }
        }
    };

    const done = () => {
        setOpen(false);
        setTimeout(() => {
            setSection(1);
        }, 200);
    };

    const revoke = useCallback(
        async (streamId: number, profileId: string) => {
            await api.accessToken.revoke(profileId, streamId);
            getAccessTokens();
        },
        [getAccessTokens]
    );

    const redirect = async (streamId: number, profileId: string) => {
        const state = {
            clientId: params.clientId,
            projectId: params.projectId,
            streamId: streamId,
            profileId: profileId,
        };
        // if (project.ProjectTypeId === 5 || project.ProjectTypeId === 8) {
        //   setAccessTokenModalHeader('Influencer Access Token Link');
        //   setAccessTokenModalBody('Please send the following link to your selected influencer:');
        //   setInfluencerLink(`${window.location.origin}/brandInfluencer?state=${JSON.stringify({ ...state, isInfluencer: true })}&profileId`);
        //   setOpen(false);
        //   setInfluencerLinkOpen(true);
        // } else {
        const origin = window.location.origin.replace("http:", "https:");
        let url = "";
        if (streamId === 8) {
            url = `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/profile&response_type=token&scope=email,pages_show_list,ads_management,pages_manage_posts,pages_read_engagement&state=${JSON.stringify(
                state
            )}`;
        } else if (streamId === 9) {
            url = `https://www.facebook.com/v18.0/dialog/oauth?client_id=1519872365497154&redirect_uri=https://app.amasocial.co.za/profile&response_type=token&scope=pages_show_list,instagram_basic,pages_read_engagement,public_profile,email,instagram_manage_comments,instagram_manage_insights,instagram_content_publish&state=${JSON.stringify(
                state
            )}`;
        } else if (streamId === 11) {
            url = `https://www.linkedin.com/oauth/v2/authorization?client_id=78y7hijgpe4o35&redirect_uri=https://app.amasocial.co.za/profile&response_type=code&scope=r_basicprofile+r_emailaddress+r_organization_social+w_organization_social+rw_organization_admin+w_member_social&state=${JSON.stringify(
                state
            )}`;
        }
        setAccessTokenModalHeader("Access Token Link");
        setAccessTokenModalBody("Please send the following link to the client:");
        setInfluencerLink(url);
        setOpen(false);
        setInfluencerLinkOpen(true);
        //}
    };

    const deleteProfile = async (binRuleId: Number, profileId: string, streamId: number, e: React.MouseEvent) => {
        e.stopPropagation();
        let copied = [...accessTokens];
        const index = copied.map((x) => x.ProfileId).indexOf(profileId);
        copied.splice(index, 1);
        setAccessTokens(copied);
        await api.accessToken.delete(binRuleId, profileId, streamId, params.projectId);
    };

    const InspectToken = async (accessToken: string, streamId: Number, e: React.MouseEvent) => {
        e.stopPropagation();
        var result = new Response();

        switch (streamId) {
            case 8:
                result = await fetch(
                    `https://graph.facebook.com/debug_token?input_token=${accessToken}&access_token=EAAEt7PalZBmMBAImgTQc4ypNMcFZBw2aFqx32nKtX8n85GDTs9KPnfvZAUnTSJ2CcLk6ynZAZAPHqAOn5MbHddfqrxraj4CGfDZAvAeFzxTVZBBIGfJgiToU3BtEpx0xQmgJzSsTXEHrLVNFxZBlh5pZActHZA4UB24ngiEvXiIljbgibRBm4qk9xqXLuV34B93D8ZD`
                );
                const data: { data: FacebookInstagramAccessTokenCheck } = await result.json();

                var dateToExpire = moment.unix(Number(data.data.expires_at)).format("YYYY-MM-DD HH:mm");
                var dateGranted = moment.unix(Number(data.data.issued_at)).format("YYYY-MM-DD HH:mm");
                var isValid = data.data.is_valid ? "Yes" : "No";

                if (data.data.expires_at > 0) {
                    return toast.warning(
                        <div>
                            <b>Token Expiry Date:</b> {dateToExpire}
                            <br />
                            <b>Is Valid:</b> {isValid}
                            <br />
                            <b>Date Granted:</b> {dateGranted}
                        </div>,
                        {
                            autoClose: 30000,
                        }
                    );
                } else {
                    return toast.success(
                        <div>
                            <b>Token Expiry Date:</b> Never
                            <br />
                            <b>Is Valid:</b> {isValid}
                            <br />
                            <b>Date Granted:</b> {dateGranted}
                        </div>,
                        {
                            autoClose: 30000,
                        }
                    );
                }

            case 9:
                result = await fetch(
                    `https://graph.facebook.com/debug_token?input_token=${accessToken}&access_token=EAAKv5hoZCBA4BAC2rPVTuoxs5ykyh8wUBZCoh0LvzEgWgkaSQ2kX6GuBaqJOzZAAWamfZBQlcYAnpffQ8ubreZBegYhj7pOFQpYkMTI6uobO1nPxI0txPQJEXioTZAXwJcFJUTx8z5UZBGAf2kYaDKc215RXZAnW77bZBFjlVD7daL0bTxJ8ynmN3qb5i0UE7I1IZD`
                );
                const data1: { data: InstagramAccessTokenCheck } = await result.json();

                var dateToExpire = moment.unix(Number(data1.data.expires_at)).format("YYYY-MM-DD HH:mm");
                var dateGranted = moment.unix(Number(data1.data.issued_at)).format("YYYY-MM-DD HH:mm");
                var isValid = data1.data.is_valid ? "Yes" : "No";
                var hasError = data1.data.error != null ? true : false;

                if (hasError) {
                    return toast.warning(<div>{data1.data.error.message}</div>, {
                        autoClose: 30000,
                    });
                } else if (data1.data.expires_at > 0) {
                    return toast.warning(
                        <div>
                            <b>Token Expiry Date:</b> {dateToExpire}
                            <br />
                            <b>Is Valid:</b> {isValid}
                            <br />
                            <b>Date Granted:</b> {dateGranted}
                        </div>,
                        {
                            autoClose: 30000,
                        }
                    );
                } else {
                    return toast.success(
                        <div>
                            <b>Token Expiry Date:</b> Never
                            <br />
                            <b>Is Valid:</b> {isValid}
                            <br />
                            <b>Date Granted:</b> {dateGranted}
                        </div>,
                        {
                            autoClose: 30000,
                        }
                    );
                }

            case 11:
                var res = await api.accessToken.validateLinkedInToken(accessToken).then(async (data: LinkedInAccessTokenCheck) => {
                    var dateToExpire = moment.unix(Number(data.expires_at)).format("YYYY-MM-DD HH:mm");
                    var dateGranted = moment.unix(Number(data.created_at)).format("YYYY-MM-DD HH:mm");
                    var isValid = data.active ? "Yes" : "No";
                    var status = data.status;

                    if (data.status == "expired") {
                        return toast.error(
                            <div>
                                <b>Token Expiry Date:</b> {dateToExpire}
                                <br />
                                <b>Is Valid:</b> {isValid}
                                <br />
                                <b>Date Granted:</b> {dateGranted}
                                <br />
                                <b>Status:</b> {status}
                            </div>,
                            {
                                autoClose: 30000,
                            }
                        );
                    } else if (data.expires_at > 0) {
                        return toast.warning(
                            <div>
                                <b>Token Expiry Date:</b> {dateToExpire}
                                <br />
                                <b>Is Valid:</b> {isValid}
                                <br />
                                <b>Date Granted:</b> {dateGranted}
                                <br />
                                <b>Status:</b> {status}
                            </div>,
                            {
                                autoClose: 30000,
                            }
                        );
                    } else {
                        return toast.success(
                            <div>
                                <b>Token Expiry Date:</b> Never
                                <br />
                                <b>Is Valid:</b> {isValid}
                                <br />
                                <b>Date Granted:</b> {dateGranted}
                                <br />
                                <b>Status:</b> {status}
                            </div>,
                            {
                                autoClose: 30000,
                            }
                        );
                    }
                });
        }
    };

    const openLink = () => {
        setTimeout(() => {
            setSection(1);
        }, 200);
    };

    const promptClick = () => {
        setPromptOpen(false);
        setOpen(true);
    };

    const copyText = () => {
        navigator.clipboard.writeText(influencerLink);
        setLinkClicked(true);
        setTimeout(() => {
            setLinkClicked(false);
        }, 2000);
    };

    useEffect(() => {
        api.accessToken.getAll(params.projectId).then((data: AccessTokenType[]) => {
            if (data.some((x) => x.AccessToken === "" || x.AccessToken === null || x.AccessToken === undefined)) {
                setPromptOpen(true);
            }
        });
    }, [params.projectId, setOpen]);

    useEffect(() => {
        if (!open) {
            const timeout = setTimeout(() => {
                setSection(1);
            }, 200);
            getAccessTokens();
            return () => clearTimeout(timeout);
        }
    }, [open, getAccessTokens]);

    useEffect(() => {
        if (open) {
            getAccessTokens();
        }
    }, [open, getAccessTokens]);

    return (
        <>
            <Modal id="access-token-modal" open={open} setOpen={setOpen}>
                <ModalHeader>
                    <p>Access Token Management</p>
                </ModalHeader>
                <ModalBody>
                    {loading ? (
                        <i className="fal fa-spinner fa-spin"></i>
                    ) : (
                        section === 1 && (
                            <div className="section-1">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="w-50">Stream</th>
                                            <th className="w-100">Profile</th>
                                            <th className="w-50">Status</th>
                                            <th className="w-50"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {accessTokens.map((x, i) => (
                                            <tr key={i}>
                                                <td className="w-50">
                                                    <i className={`fab fa-${getStreamName(x.StreamId)}`}></i>
                                                </td>
                                                <td className="w-100">{x.Name}</td>
                                                <td onClick={(e) => onClick(x.ProfileId, x.StreamId, x.AccessToken, x.IsValid, e)}>
                                                    {!x.AccessToken ? (
                                                        <span title="Click to grant token" className="status missing">
                                                            Not Granted
                                                        </span>
                                                    ) : x.IsValid ? (
                                                        <span title="Click to revoke token" className="status granted">
                                                            Granted
                                                        </span>
                                                    ) : (
                                                        <span title="Click to grant token" className="status">
                                                            Invalid
                                                        </span>
                                                    )}
                                                </td>
                                                <td>
                                                    {x.StreamId == 8 || x.StreamId == 9 || x.StreamId == 11 ? <i className="fal fa-repeat" title="Check Access Token" onClick={(e) => InspectToken(x.AccessToken, x.StreamId, e)}></i> : <></>}
                                                    <i className="fal fa-trash" title="Delete Profile" onClick={(e) => deleteProfile(x.BinRuleId, x.ProfileId, x.StreamId, e)}></i>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )
                    )}
                    {section === 2 && (
                        <div className="section-2">
                            <p className="heading">Please select a platform:</p>
                            {streams.map((x, i) => (
                                <div key={i} onClick={() => selectStream(x.id)}>
                                    <i className={`fab fa-${getStreamName(x.id)}`}></i>
                                    <span>{x.name}</span>
                                </div>
                            ))}
                        </div>
                    )}
                    {section === 3 && (
                        <div className="section-3">
                            <p>Please click on the link below or paste it in the browser of your choice</p>
                            {loading ? (
                                <i className="fal fa-spinner fa-spin"></i>
                            ) : (
                                <a href={link} target="_blank" rel="noreferrer" onClick={openLink}>
                                    {link}
                                </a>
                            )}
                        </div>
                    )}
                </ModalBody>
                <ModalFooter>
                    {section === 1 && <button onClick={() => setSection(2)}>Add Profile</button>}
                    {section === 2 && (
                        <button className="p-50" onClick={() => setSection(1)}>
                            Back
                        </button>
                    )}
                    {section === 3 && (
                        <div className="button-group">
                            <button className="p-50" onClick={() => setSection(2)}>
                                Back
                            </button>
                            <button className="p-50" onClick={done}>
                                Done
                            </button>
                        </div>
                    )}
                </ModalFooter>
            </Modal>
            <Modal className="influencer-link-modal" open={influencerLinkOpen} setOpen={setInfluencerLinkOpen}>
                <ModalHeader>
                    <p>{accessTokenModalHeader}</p>
                </ModalHeader>
                <ModalBody>
                    {/* <p>{accessTokenModalBody}</p> */}
                    <p>Please click on the link below or paste it in the browser of your choice</p>
                    <input type="text" value={influencerLink} readOnly />
                    <p className={`message${linkClicked ? " show" : ""}`}>Copied!</p>
                    <button onClick={copyText}>Copy Link</button>
                </ModalBody>
            </Modal>
            <div className={`access-token-prompt${promptOpen ? " open" : ""}`} onClick={promptClick}>
                <i
                    className="fal fa-times"
                    onClick={(e) => {
                        e.stopPropagation();
                        setPromptOpen(false);
                    }}
                ></i>
                <p>
                    You have profiles with invalid access tokens. Click <span>here</span> to manage them.
                </p>
            </div>
        </>
    );
}

export default AccessToken;
